import { TypographyProps } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography/Typography';
import { SpacingProps } from '@mui/system';
import { OverridableStringUnion } from '@mui/types';

import { StyledText } from './Text.styles';

export type TextProps = {
  fontWeight?: number;
  textColor?: string;
  variant?: OverridableStringUnion<Variant, TypographyPropsVariantOverrides>;
} & TypographyProps &
  SpacingProps;

export const Text = ({ children, textColor, fontWeight, variant, ...rest }: TextProps): JSX.Element => {
  return (
    <StyledText variant={variant} fontWeight={fontWeight} textColor={textColor} {...rest}>
      {children}
    </StyledText>
  );
};

Text.defaultProps = {
  fontWeight: 500,
};
